import { createGlobalStyle, css } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  ${() => css`
    body {
      font-family: 'Montserrat', sans-serif;
    }
  `}
`
